import moment from 'moment';
// @ts-ignore
import 'moment/locale/en-gb';

moment.locale('en');

export default moment;